import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SelectTrigger } from "@activecollab/components";
import moment from "moment";
import PropTypes from "prop-types";
import { getConfigOption } from "~/store/selectors/selector.configOptions.jsx";
import { getProjectById } from "~/store/selectors/selector.projects.jsx";
import FormatDate from "../Formatters/FormatDate.jsx";
import { useSecurity } from "../Hooks/useSecurity.js";
import SelectDateNonWorkingDays from "../SelectDate/SelectDateNonWorkingDays.jsx";

const TimeRecordFormHeader = ({ title, timestamp, isProjectTitle, onChange, projectId, editableDate }) => {
  const { t } = useTranslation();
  const can = useSecurity();

  const project = useSelector((state) => getProjectById(state, projectId));
  const canTrackTimeForOtherUsers = can(["can_track_time_for_others"], project);
  const backtrackMaxDays = useSelector((state) => getConfigOption(state, "backtrack_time_max_days"));
  const disableDaysBefore = canTrackTimeForOtherUsers ? null : moment().subtract(backtrackMaxDays, "days");

  return (
    <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
      <div className="tw-truncate tw-mr-4 tw-text-base">
        {isProjectTitle && <span className="tw-italic">{t("Project")}: </span>}
        <span className="tw-font-bold">{title}</span>
      </div>
      {editableDate ? (
        <SelectDateNonWorkingDays
          trigger={(text) => <SelectTrigger className="tw-w-auto">{text}</SelectTrigger>}
          onSave={onChange}
          selectedDays={{ from: timestamp, to: timestamp }}
          selectionMode="daily"
          required
          defaultTimezoneAware
          type="selectable_global_day_off"
          weekendIsSelectable
          disableDaysBefore={disableDaysBefore}
          position="bottom-end"
        />
      ) : (
        <SelectTrigger
          className="tw-w-auto"
          disabled
        >
          <FormatDate value={timestamp} />
        </SelectTrigger>
      )}
    </div>
  );
};

TimeRecordFormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  timestamp: PropTypes.number,
  isProjectTitle: PropTypes.bool,
  onChange: PropTypes.func,
  editableDate: PropTypes.bool,
};

TimeRecordFormHeader.defaultProps = {
  timestamp: moment().unix(),
  isProjectTitle: false,
};

TimeRecordFormHeader.displayName = "TimeRecordFormHeader";

export default TimeRecordFormHeader;
